'use client'

import { useEffect, useState } from 'react'

/** The media query every reduced-motion decision in the app reads. */
export const PREFERS_REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)'

/**
 * Whether the viewer asked for reduced motion (Issue #14363).
 *
 * The component half of a belt-and-braces split: a caller uses this to
 * decline to apply a motion class at all, and `globals.css` carries a
 * `prefers-reduced-motion` rule for the setting changing mid-animation.
 *
 * `false` on the server and the first client render, so the markup matches
 * across hydration; the real answer arrives in the effect. Moved here from
 * the recording bar, which still re-exports it from its old path.
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const query = window.matchMedia(PREFERS_REDUCED_MOTION_QUERY)
    const read = () => setReduced(query.matches)
    read()
    query.addEventListener?.('change', read)
    return () => query.removeEventListener?.('change', read)
  }, [])

  return reduced
}
